function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Vue from 'vue';
import ListenersMixin from '../../mixins/listeners.js';
import { slot } from '../../utils/slot.js';
export default Vue.extend({
  name: 'QPageSticky',
  mixins: [ListenersMixin],
  inject: {
    layout: {
      "default": function _default() {
        console.error('QPageSticky needs to be child of QLayout');
      }
    }
  },
  props: {
    position: {
      type: String,
      "default": 'bottom-right',
      validator: function validator(v) {
        return ['top-right', 'top-left', 'bottom-right', 'bottom-left', 'top', 'right', 'bottom', 'left'].includes(v);
      }
    },
    offset: {
      type: Array,
      validator: function validator(v) {
        return v.length === 2;
      }
    },
    expand: Boolean
  },
  computed: {
    attach: function attach() {
      var pos = this.position;
      return {
        top: pos.indexOf('top') > -1,
        right: pos.indexOf('right') > -1,
        bottom: pos.indexOf('bottom') > -1,
        left: pos.indexOf('left') > -1,
        vertical: pos === 'top' || pos === 'bottom',
        horizontal: pos === 'left' || pos === 'right'
      };
    },
    top: function top() {
      return this.layout.header.offset;
    },
    right: function right() {
      return this.layout.right.offset;
    },
    bottom: function bottom() {
      return this.layout.footer.offset;
    },
    left: function left() {
      return this.layout.left.offset;
    },
    style: function style() {
      var posX = 0,
          posY = 0;
      var attach = this.attach,
          dir = this.$q.lang.rtl === true ? -1 : 1;

      if (attach.top === true && this.top !== 0) {
        posY = "".concat(this.top, "px");
      } else if (attach.bottom === true && this.bottom !== 0) {
        posY = "".concat(-this.bottom, "px");
      }

      if (attach.left === true && this.left !== 0) {
        posX = "".concat(dir * this.left, "px");
      } else if (attach.right === true && this.right !== 0) {
        posX = "".concat(-dir * this.right, "px");
      }

      var css = {
        transform: "translate(".concat(posX, ", ").concat(posY, ")")
      };

      if (this.offset) {
        css.margin = "".concat(this.offset[1], "px ").concat(this.offset[0], "px");
      }

      if (attach.vertical === true) {
        if (this.left !== 0) {
          css[this.$q.lang.rtl === true ? 'right' : 'left'] = "".concat(this.left, "px");
        }

        if (this.right !== 0) {
          css[this.$q.lang.rtl === true ? 'left' : 'right'] = "".concat(this.right, "px");
        }
      } else if (attach.horizontal === true) {
        if (this.top !== 0) {
          css.top = "".concat(this.top, "px");
        }

        if (this.bottom !== 0) {
          css.bottom = "".concat(this.bottom, "px");
        }
      }

      return css;
    },
    classes: function classes() {
      return "fixed-".concat(this.position, " q-page-sticky--").concat(this.expand === true ? 'expand' : 'shrink');
    }
  },
  render: function render(h) {
    var content = slot(this, 'default');
    return h('div', {
      staticClass: 'q-page-sticky row flex-center',
      "class": this.classes,
      style: this.style,
      on: _objectSpread({}, this.qListeners)
    }, this.expand === true ? content : [h('div', content)]);
  }
});